import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { FrownOutlined } from "@ant-design/icons";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #f9f9f9, #e6f7ff)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Result
        icon={<FrownOutlined style={{ fontSize: "64px", color: "#ff4d4f" }} />}
        status="404"
        title={<span style={{ fontSize: "36px", fontWeight: 600 }}>Page Not Found</span>}
        subTitle="Sorry, the page you're trying to access doesn't exist or has been moved."
        extra={
          <Button type="primary" size="large" onClick={() => navigate("/home")}>
            Back to Home
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
